import React, { useState } from 'react';
import { Alert } from 'antd';
import LocalStorage from '@src/hooks/localStorage';

const DISMISSED_KEY = 'emp.dpiDeprecationAlert.dismissed';

export interface IDpiDeprecationAlertProps {
  feature: string;
}

const DpiDeprecationAlert: React.FC<IDpiDeprecationAlertProps> = ({ feature }) => {
  const [dismissed, setDismissed] = useState(() => Boolean(LocalStorage.get(DISMISSED_KEY)));

  if (dismissed) {
    return null;
  }

  return (
    <Alert
      type="warning"
      showIcon
      banner
      closable
      onClose={() => {
        LocalStorage.set({ key: DISMISSED_KEY, value: { dismissed: true } });
        setDismissed(true);
      }}
      message={`Deprecating soon: ${feature} have been migrated to our newly launched Digital Patterns Insights (DPI) product (dpi.conviva.com).`}
      style={{ marginBottom: 8 }}
    />
  );
};

export default DpiDeprecationAlert;
